"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMutationFunction = exports.mutateWithErrorHandling = exports.cleanInput = void 0;
const lodash_mapvalues_1 = __importDefault(require("lodash.mapvalues"));
const lodash_isplainobject_1 = __importDefault(require("lodash.isplainobject"));
function cleanInput(input) {
    return (0, lodash_mapvalues_1.default)(input, value => {
        if (typeof value === 'string') {
            return value.trim().length > 0 ? value.trim() : null;
        }
        if ((0, lodash_isplainobject_1.default)(value)) {
            return cleanInput(value);
        }
        return value;
    });
}
exports.cleanInput = cleanInput;
async function mutateWithErrorHandling(app, params, client) {
    const mutate = client === undefined
        ? app.$apollo.mutate.bind(app.$apollo)
        : typeof client === 'function'
            ? client
            : client.mutate.bind(client);
    try {
        const result = await mutate({
            ...params,
            variables: params.variables != null ? cleanInput(params.variables) : undefined,
        });
        if (result == null) {
            return { success: false };
        }
        return { success: true, data: result.data };
    }
    catch (error) {
        const { onError, context } = params;
        const errorHandlerResult = onError != null ? onError(error, app, context) : undefined;
        return {
            success: false,
            errors: errorHandlerResult === null || errorHandlerResult === void 0 ? void 0 : errorHandlerResult.allErrors,
            validationRuleViolations: errorHandlerResult === null || errorHandlerResult === void 0 ? void 0 : errorHandlerResult.validationRuleViolations,
        };
    }
}
exports.mutateWithErrorHandling = mutateWithErrorHandling;
function createMutationFunction(mutation, onError) {
    return (app, params, client) => {
        return mutateWithErrorHandling(app, {
            mutation,
            onError,
            ...params,
        }, client);
    };
}
exports.createMutationFunction = createMutationFunction;
//# sourceMappingURL=mutation.js.map